export const SIGN_TYPES = {
  any: 'ANY',
  hybrid: 'HYBRID',
  qualified: 'QUALIFIED',
  sms: 'SMS',
} as const;
